var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"shareDownload"},[_c('div',{staticClass:"downloadBtn"},[_c('p',[_vm._v("\"小小明霞\"")]),_vm._v(" "),_c('p',[_vm._v("邀请你加入Quick Live")]),_vm._v(" "),_c('div',{on:{"click":_vm.invitation_share_btn}},[_vm._v("\n\t\t\t\t立即下载\n\t\t\t")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-03b714ff","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shareDownload.vue
// module id = null
// module chunks = 